import { render, staticRenderFns } from "./CoPill.vue?vue&type=template&id=f2547f6a&scoped=true&"
import script from "./CoPill.vue?vue&type=script&lang=js&"
export * from "./CoPill.vue?vue&type=script&lang=js&"
import style0 from "./CoPill.vue?vue&type=style&index=0&id=f2547f6a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2547f6a",
  null
  
)

export default component.exports